import { useWindowDimension } from '@woolworthslimited/core-components-react/shared/hooks/useWindowDimension';

import { isSmallDeviceOrGreater } from '@contentservice/shared/services/breakpoint/breakpoint.service';

import {
  GraphicLinkContentStyle,
  IGraphicLink,
} from './graphic-link-list-model';
import styles from './graphic-link-list.module.scss';

/** Link Components that shows optional small graphic above text link in a rectangular space. Usually listed 2-5 in a row. */
export const GraphicLinkList = ({ linkList }: { linkList: IGraphicLink[] }) => {
  const [width] = useWindowDimension();
  const isDesktop = isSmallDeviceOrGreater(width);

  const background = linkList[0]?.background || GraphicLinkContentStyle.filled;

  if (isDesktop) {
    return (
      <div className={styles.graphicLinkList + ' ' + styles[background]}>
        {linkList.map((item, i) => (
          <a
            key={i + item.linkLabel}
            className={styles.linkWrapper}
            href={item.linkUrl}
          >
            {item.graphicUrl && (
              <img
                src={item.graphicUrl}
                aria-hidden={true}
                alt={item.graphicAltText}
              />
            )}
            <span className={styles.linkLabel}>{item.linkLabel}</span>
          </a>
        ))}
      </div>
    );
  } else {
    return (
      <ul className={styles.graphicLinkListMobile + ' ' + styles[background]}>
        {linkList.map((item, i) => (
          <li key={i + item.linkLabel}>
            <a className={styles.linkWrapper} href={item.linkUrl}>
              <span className={styles.linkLabel}>{item.linkLabel}</span>
            </a>
          </li>
        ))}
      </ul>
    );
  }
};
